/**
 * 项目默认配置项
 *
 */

export default {
  serverUrl: "",
  fileUrl: ""
};
